<template>
  <div class="home_page_wrap">
    <Header></Header>
    <div class="home_page_main">
      <div class="home_page_menu">
        <div class="home_page_menu_box" v-if="isOpen">
          <!-- <div class="home_page_menu_title">
            <img src="../../../static/images/course/home-icon.png" alt="">
            <span>首页</span>
          </div> -->
          <ul>
            <!-- <span class="icon_span_acti" v-if="iconToo[i.name]" :style="{backgroundImage: `url(${iconToo[i.name].ActiveSrc})`}"></span>
            <span class="icon_span" v-if="iconToo[i.name]" :style="{backgroundImage: `url(${($route.path == iconToo[i.name].url && tabMenuId == i.menuId) ? iconToo[i.name].ActiveSrc : iconToo[i.name].src})`}"></span> -->

            <li
              v-for="(item,index) in menuList"
              :key="index"
              :class="{active : index===curId}"
              @click="tabSwitch(item,index)"
            >
                <span v-if="iconToo[item.name]"
                      :style="{backgroundImage: `url(${index===curId?iconToo[item.name].ActiveSrc:iconToo[item.name].src})`}"
                      class="icon"></span>
              <span>{{item.name}}</span>
            </li>

            <li v-if="professional == 2" @click="openUrl('税收政策库')">
              <span class="icon" :style="{backgroundImage: `url(${iconToo['税收政策库'].src})`}"></span>
              <span>税收政策库</span>
            </li>
            <li v-if="professional==='1' && productFlag==='3'" @click="openUrl('审计准则')">
              <span class="icon" :style="{backgroundImage: `url(${iconToo['审计准则'].src})`}"></span>
              <span>审计准则</span>
            </li>
            <li v-if="professional==='1' && productFlag==='3'" @click="openUrl('会计准则')">
              <span class="icon" :style="{backgroundImage: `url(${iconToo['会计准则'].src})`}"></span>
              <span>会计准则</span>
            </li>
          </ul>
        </div>
        <img src="../../../static/images/course/close.png" alt="" v-if="isOpen" class="switchImg close"
             @click="isOpen=false">
        <img src="../../../static/images/course/open.png" alt="" v-else class="switchImg open" @click="isOpen=true">
      </div>
      <div class="home_page_content" :style="isOpen?'width: calc(100% - 120px)':'width: 100%'">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
  import Header from '../header/header'

  export default {
    components: {
      Header
    },
    data() {
      return {
        routerPermissions:[], // 获取产品路由权限
        deptId : sessionStorage.getItem('deptId'),
        userType : sessionStorage.getItem('userType'),
        productFlag : sessionStorage.getItem('productFlag'),
        professional : sessionStorage.getItem('professional'),
        isOpen: true,
        curId: 0,
        menuList: [],
        iconToo: {
          "课证融通": {
            src: require('@/assets/icon/szrt.png'),
            ActiveSrc: require('@/assets/icon/szrtActive.png'),
          },
          "课程学习": {
            src: require('@/assets/icon/szrt.png'),
            ActiveSrc: require('@/assets/icon/szrtActive.png'),
          },
          "单项训练": {
            src: require('@/assets/icon/dxxl.png'),
            ActiveSrc: require('@/assets/icon/dxxlActive.png'),
          },
          "综合实训": {
            src: require('@/assets/icon/zhsx.png'),
            ActiveSrc: require('@/assets/icon/zhsxActive.png'),
          },
          "真实任务": {
            src: require('@/assets/icon/zsrw.png'),
            ActiveSrc: require('@/assets/icon/zsrwActive.png'),
          },
          "课程管理": {
            src: require('@/assets/icon/kcgl.png'),
            ActiveSrc: require('@/assets/icon/kcglActive.png'),
          },
          "任务管理": {
            src: require('@/assets/icon/kcgl.png'),
            ActiveSrc: require('@/assets/icon/kcglActive.png'),
          },
          "资源库": {
            src: require('@/assets/icon/zyk.png'),
            ActiveSrc: require('@/assets/icon/zykActive.png'),
          },
          "企业微课": {
            src: require('@/assets/icon/qywk.png'),
            ActiveSrc: require('@/assets/icon/qywkActive.png'),
          },
          "应用中心": {
            src: require('@/assets/icon/yyzx.png'),
            ActiveSrc: require('@/assets/icon/yyzxActive.png'),
          },
          "教学班": {
            src: require('@/assets/icon/jxb.png'),
            ActiveSrc: require('@/assets/icon/jxbActive.png'),
          },
          "课程库": {
            src: require('@/assets/icon/kck.png'),
            ActiveSrc: require('@/assets/icon/kckActive.png'),
          },
          "测评考试": {
            src: require('@/assets/icon/ksbm.png'),
            ActiveSrc: require('@/assets/icon/ksbmActive.png'),
          },
          "税收政策库": {
            src: require('@/assets/icon/ksbm.png'),
            ActiveSrc: require('@/assets/icon/ksbmActive.png'),
          },
          "审计准则": {
            src: require('@/assets/icon/kkjh.png'),
            ActiveSrc: require('@/assets/icon/kkjhActive.png'),
          },
          "会计准则": {
            src: require('@/assets/icon/ksbm.png'),
            ActiveSrc: require('@/assets/icon/ksbmActive.png'),
          },
        },
      }
    },
    created(){
      if (sessionStorage.getItem('routerPermissions')){
        try {
          this.routerPermissions = JSON.parse( this.$AES.AES_Decrypt(sessionStorage.getItem('routerPermissions'))  )
        }catch (e) {
          console.error( 'NewHome.created',e)
        }
      }
    },
    mounted() {
      let menuArr = []
      let prodName = ''
      if (this.productFlag === '1') {
        prodName = '课证融通'
      }
      if (this.productFlag === '2') {
        prodName = '单项训练'
      }
      if (this.productFlag === '3') {
        prodName = '综合实训'
      }
      if (this.productFlag === '4') {
        prodName = '真实任务'
      }
      if (this.productFlag === '5') {
        prodName = '技能测评'
      }
      if (this.productFlag === '7') {
        prodName = '综合实训2.0'
      }
      if (this.userType === '2' || this.userType === '3') {
        if (this.productFlag === '1') {
          menuArr = [{name: '课证融通', hidden: true, path: '/TheoryCourse/studentClass'}]
        } else if (this.productFlag === '2') {
          menuArr = [{name: '单项训练', hidden: true, path: '/IndividualTraining/studentClass'}]
        } else if (this.deptId === '719' && this.professional === '2') {
          menuArr.push({name: '应用中心', hidden: true, path: '/IndividualTraining/appCenter'})
        } else if (this.productFlag === '3') {
          // 机构（ 综合实训教材 ）  deptId == 6485 隐藏 企业微课和应用中心
          if (this.deptId === '6485') {
            menuArr = [{name: '综合实训', hidden: true, path: '/PracticalTraining/studentClass'}]
          } else {
            menuArr = [{name: '综合实训', hidden: true, path: '/PracticalTraining/studentClass'}]
            menuArr.push({name: '企业微课', hidden: true, path: '/PracticalTraining/microLecture'})
            menuArr.push({name: '应用中心', hidden: true, path: '/PracticalTraining/appCenter'})
          }

        } else if (this.productFlag === '4') {
          menuArr = [{name: '真实任务', hidden: true, path: '/RealTask/studentClass'}]
          menuArr.push({name: '企业微课', hidden: true, path: '/RealTask/microLecture'})
          menuArr.push({name: '应用中心', hidden: true, path: '/RealTask/appCenter'})
        }


      } else if (this.routerPermissions.length){
          let routerArr = []
          this.routerPermissions.forEach(v => {
              if (v.appFlag === 'sharingcenter') {
                routerArr = v.arr
                //====================大赛练习==============
                // v.arr.forEach(n=>{
                //   if(n.name=='课证融通'){
                //     n.children.push({name: '大赛练习', hidden: true, path: '/competitionPractice'})
                //   }
                // })
                //==========================================
                v.arr.forEach(n => {
                  if (n.name === '单项训练' && this.deptId === '719' && this.professional === '2') {
                    n.children.push({name: '应用中心', hidden: true, url: '/IndividualTraining/appCenter'})
                  }
                })
              }
            })
            if (routerArr.length > 0) {
              routerArr.forEach(v => {
                if (v.name === prodName) {
                  v.children.forEach(val => {
                    menuArr.push({
                      name: val.name,
                      hidden: true,
                      path: val.url
                    })
                  })
                }
              })
            }
        }


      this.menuList = menuArr
      this.menuList.forEach((v, i) => {
        if (this.$route.path === v.path) {
          this.curId = i
        }
        if (this.$route.path === '/EditCourse' || this.$route.path === '/EditTask') {
          if (v.name === '课程管理') {
            this.curId = i
          }
        }
      })
    },
    methods: {
      tabSwitch(item, i) {
        if (item.name === '资源库') {
          let token = localStorage.getItem('Authorization')
          console.log('--token--', item.path + '#/?token=' + token)
          window.open(item.path + '#/?token=' + token)
        } else if (item.name === '大赛练习') {
          // let token = localStorage.getItem('Authorization')
          // let token = 'b37b09b4-fed0-489c-bf85-bba05116161c'
          // window.open(item.path+'#/planHome?pattern_lx=0&token='+token)
          this.$router.push('/competitionPractice')
        } else {
          this.curId = i
          this.$router.push(item.path)
        }
        this.$store.state.pageIndex = 1;
      },
      openUrl(type) {
        if (type === '税收政策库') {
          window.open('https://fgk.chinatax.gov.cn/zcfgk/index.html')
        } else if (type === '审计准则') {
          window.open('https://www.cicpa.org.cn/ztzl1/Professional_standards/')
        } else if (type === '会计准则') {
          window.open('https://www.casc.org.cn/zzfb/')
        }
      }
    }
  }
</script>
<style lang="scss">
  .home_page_wrap {
    width: 100%;
    height: 100%;
    background: #F6F8FB;

    .home_page_main {
      height: calc(100% - 64px);
      display: flex;
      justify-content: space-between;
      overflow: auto;

      .home_page_menu {
        height: 100%;
        background: #fff;
        position: relative;

        .home_page_menu_box {
          width: 120px;
        }

        .home_page_menu_title {
          height: 40px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #5397F7;

          img {
            height: 14px;
            margin: 0 10px 0 15px;
          }

          span {
            font-size: 12px;
            font-weight: normal;
            line-height: 40px;
            color: #5397F7;
          }
        }

        ul {
          li {
            height: 32px;
            background: #fff;
            border-radius: 4px;
            margin: 10px;
            font-size: 12px;
            font-weight: normal;
            color: #5D646E;
            padding-left: 33px;
            box-sizing: border-box;
            position: relative;
            line-height: 32px;
            cursor: pointer;

            &:hover {
              background: #F6F8FB;
              color: #5D646E;
            }

            .icon {
              width: 14px;
              height: 14px;
              position: absolute;
              left: 10px;
              top: 0;
              bottom: 0;
              margin: auto;
              background-size: 100% 100%;
            }
          }

          .active {
            background: #5397F7 !important;
            color: #fff !important;
          }
        }

        .switchImg {
          width: 16px;
          position: absolute;
          right: -16px;
          top: 0;
          bottom: 0;
          margin: auto;
          cursor: pointer;
        }
      }

      .home_page_content {
        min-width: 1064px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/homepage/homepage.vue